<template>
  <div id="login-wrap">
    <!--    头部-->
    <div class="login-header">
<!--      <img class="logo" src="./img/loginLogo.png" />-->
      <div class="login-header__right" @click="showDialog">
        <img src="./img/shape.png" />
        <div class="shape"></div>
      </div>
    </div>
    <!--    登录表单-->
    <div class="login__form">
      <template v-if="status == 0">
        <div class="login__form__context">
          <div class="title">账号登录</div>
          <el-input
            class="getInput"
            v-model="account"
            placeholder="用户名"
          ></el-input>
          <el-input
            class="getInput"
            v-model="password"
            show-password
            placeholder="密码"
          >
            <!--          <div-->
            <!--            slot="suffix"-->
            <!--            class="icon-style"-->
            <!--            :class="elIcon"-->
            <!--            @click="flag = !flag"-->
            <!--          ></div>-->
          </el-input>
          <div class="remember">
            <el-checkbox
              class="checkbox"
              v-model="checked"
              label="记住密码"
              name="type"
            ></el-checkbox>
            <p @click="clickForgetPwd()">忘记密码</p>
          </div>
          <el-button class="button" @click="onSubmit" round type="primary">
            登录
          </el-button>
        </div>
      </template>

      <template v-if="status == 1">
        <div class="login__form__context">
          <div class="title">
            <img @click="status = 0" src="./img/backLogin.png" /> 忘记密码
          </div>

          <el-form :model="phoneID" :rules="rule" ref="ruleForm">
            <el-form-item prop="id">
              <el-input
                class="getInput"
                v-model="phoneID.id"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="button"
                @click="nextStep()"
                round
                type="primary"
              >
                下一步
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <template v-if="status == 2">
        <div class="login__form__context">
          <div class="title">
            <img @click="status = 1" src="./img/backLogin.png" /> 输入验证码
          </div>
          <div class="content" style="margin-top: 40px; text-align: center">
            <div class="send">已发送至 {{ phoneID.id }}</div>
            <auth-code @finish="getCode" :getErrColor="errColor"></auth-code>
            <div class="tip" style="text-align: left; width: 100%">
              <p :style="errColor ? 'color:#F56C6C' : 'display:none'">
                请输入正确验证码
              </p>
            </div>
            <div class="recode" style="margin-top: 40px" v-if="showCountDown">
              <span style="color: #2a62ff">{{ countDown }}秒</span> 后重新获取
            </div>
            <div
              class="recode"
              style="margin-top: 40px; color: #2a62ff; cursor: pointer"
              v-if="!showCountDown"
              @click="againCode()"
            >
              重新获取
            </div>
          </div>
        </div>
      </template>

      <template v-if="status == 3">
        <div class="login__form__context">
          <div class="title">
            <img @click="status = 2" src="./img/backLogin.png" /> 重置密码
          </div>
          <el-form :model="phoneID" :rules="rule" ref="ruleForm2">
            <el-form-item prop="password">
              <el-input
                class="getInput"
                v-model="phoneID.password"
                show-password
                placeholder="密码"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                class="button"
                @click="getNewPassword()"
                round
                type="primary"
              >
                确定
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </div>
    <!--    内容文字-->
    <div class="login-context">
      <div class="login-context__top">万户安智慧用电检测</div>
      <div class="login-context__bottom">
        <p>数智电能管理</p>
        <p>7*24小时保障用电安全</p>
      </div>
    </div>
    <!--    左下角图片-->
        <div class="login-footer">
          <img class="images" src="./img/image.png" />
        </div>
    <!--    弹框-->
    <el-dialog
      top="22vh"
      center
      class="show__dialog"
      title="请扫描下方二维码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeclose"
      append-to-body
      width="764px"
    >
      <div class="show__dialog__context">
        <div class="box">
          <div class="img" id="qrcode"></div>
          <p>用户APP</p>
        </div>
        <div class="box">
          <div class="img" id="qrcode2"></div>
          <p>工具APP</p>
        </div>
      </div>
    </el-dialog>
    <div class="bom-title" @click="toout()">
       Copyright &copy;  杭州善瑟科技有限公司 版权所有 浙ICP备2022006581号-1
    </div>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import authCode from "./components/authCode";
import Vue from "vue";
import QRCode from 'qrcodejs2'
let checkPhone = (rule, value, callback) => {
  let reg = /^1[34578]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入正确的手机号码格式"));
  } else {
    callback();
  }
};
export default {
  name: "login",
  data() {
    return {
      account: "",
      checked: true,
      password: "",
      flag: true,
      dialogVisible: false,
      status: 0,
      timer: null,
      qrcode: null,
      showCountDown: true,
      phoneID: {
        id: "",
        password: "",
        oldPassword: "",
        userId: 0,
      },
      rule: {
        id: [
          {
            validator: checkPhone,
            type: "number",
            required: true,
            trigger: "blur",
          },
        ],
        password: [
          {
            min: 6,
            max: 16,
            required: true,
            trigger: "blur",
            message: "密码长度必须在6~16位！",
          },
        ],
      },
      errColor: false,
      countDown: 0,
    };
  },
  components: { authCode,QRCode },
  computed: {
    // type() {
    //   return this.flag ? "password" : "text";
    // },
    // elIcon() {
    //   return this.flag ? "open" : "close";
    // },
  },
  methods: {
    toout(){
      window.open("https://beian.miit.gov.cn/#/Integrated/index") ;
    },
    qrcodeScan (url) {//生成二维码

      let qrcode = new QRCode('qrcode', {
        width: 200,  // 二维码宽度
        height: 200, // 二维码高度
        correctLevel: 1,
        text: url
      })

    },
    qrcodeScan2 (url) {//生成二维码
      let qrcode = new QRCode('qrcode2', {
        width: 200,  // 二维码宽度
        height: 200, // 二维码高度
        correctLevel: 1,
        text: url
      })

    },
    beforeclose(){
      const codeHtml = document.getElementById("qrcode");
      const codeHtml2 = document.getElementById("qrcode2");
      codeHtml.innerHTML = "";
      codeHtml2.innerHTML = "";
      this.dialogVisible=false
    },
    geturl(){
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/app/version/getLast";
      param.data = {
        "appType": "APP_USER",
      }

      Axios.ajax(param).then((res) => {
        this.qrcodeScan(res.data.packageUrl)
      })
    },
    getTOOL(){
      let that = this;
      let param = {};
      param.method = "post";
      param.url = "/app/version/getLast";
      param.data = {

        "appType": "APP_TOOL"
      }

      Axios.ajax(param).then((res) => {

        this.qrcodeScan2(res.data.packageUrl)
      })
    },
    onSubmit() {
      //缓存用户名密码token
      localStorage.setItem("loginName", this.account);
      localStorage.setItem("loginPassword", this.password);
      let param = {};
      param.method = "post";
      param.url = "/login";
      param.data = {
        loginName: this.account,
        passwd:this.$md5(this.password),
      };
      Axios.ajax(param).then((res) => {
        if (res.resultCode == "0") {

          //按钮权限控制
          let menusList=[]
          for(let i=0;i<res.data.menus.length;i++){
            menusList.push(res.data.menus[i].menuCode)
          }
         Vue.prototype.menusList=menusList
          localStorage.setItem("menusList", JSON.stringify(menusList));
          localStorage.setItem("userName", res.data.userName);
          localStorage.setItem("userId", res.data.userId);
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("url", res.data.roleType);
          sessionStorage.removeItem("active"); //为了让登录进去时 导航栏活跃在首页

            if(  menusList.indexOf('HOME_PAGE')!='-1'){
              if (res.data.roleType == 2) {
                this.$router.push("/singerUer");
              }
              else if (res.data.roleType == 1 || res.data.roleType == 0 || res.data.roleType == 3) {
                this.$router.push("/areaUer");
              } else {
                this.$message.error("当前用户无角色!");
              }
            }else{
              this.$router.push("/stationList");
            }

        } else {
          this.$message.error("账号密码错误!");
        }
      });
      // this.$router.push("/singerUer");
    },
    showDialog() {
      this.dialogVisible = true;

      this.geturl()
      this.getTOOL()
    },
    nextStep() {
      this.$refs.ruleForm.validate((va) => {
        if (va) {
          const param = {
            method: "post",
            url: "/login/validateUser",
            data: {
              phone: this.phoneID.id,
            },
          };
          Axios.ajax(param).then((res) => {
            if (res.resultCode == 0) {
              this.getCuntDown();
              this.status = 2;
              this.showCountDown = true;
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        } else {
          return false;
        }
      });
    },
    againCode() {
      const param = {
        method: "post",
        url: "/login/validateUser",
        data: {
          phone: this.phoneID.id,
        },
      };
      Axios.ajax(param).then((res) => {
        this.getCuntDown();
        this.status = 2;
        this.showCountDown = true;
      });
    },
    getCode(code) {
      const param = {
        method: "post",
        url: "/login/validateVerifyCode",
        data: {
          phone: this.phoneID.id,
          verifyCode: code,
        },
      };
      Axios.ajax(param)
        .then((res) => {
          this.phoneID.oldPassword = res.data.oldPwd;
          this.phoneID.userId = res.data.userId;
          this.status = 3;
        })
        .catch(() => {
          this.errColor = true;
        });
    },
    getNewPassword() {
      this.$refs.ruleForm2.validate((val) => {
        if (val) {
          const para = {
            method: "post",
            url: "login/updatePwd",
            data: {
              newPwd: this.$md5(this.phoneID.password),
              oldPwd: this.phoneID.oldPassword,
              userId: this.phoneID.userId,
            },
          };
          Axios.ajax(para).then((res) => {
            this.$message.success("修改成功！");
            this.status = 0;
          });
        }
      });
    },
    getCuntDown() {
      if (!this.timer) {
        this.countDown = 60;
        this.showCountDown = true;
        this.timer = setInterval(() => {
          if (this.countDown > 0 && this.countDown <= 60) {
            this.countDown--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.showCountDown = false;
          }
        }, 1000);
      }
    },
    clickForgetPwd() {
      this.status = 1;
      this.phoneID.id = "";
      this.phoneID.oldPassword = "";
    },
  },
  mounted() {
    let that = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        if (that.$route.path == "/login") {
          if (that.status == 0) {
            that.onSubmit();
          } else if (that.status == 1) {
            that.nextStep();
          } else if (that.status == 3) {
            that.getNewPassword();
          } else {
          }
        }
      }
    };

    this.checked = localStorage.getItem("checked") == "true" ? true : false;
    if (this.checked) {
      this.account = localStorage.getItem("loginName");
      this.password = localStorage.getItem("loginPassword");
    } else {
      this.account = "";
      this.password = "";
    }
  },
  watch: {},
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
<style lang="scss">

.login-header__right{
  float: right;
}
</style>
